import { observer } from 'mobx-react';

import styles from './Duration.module.scss';

import { Input, InputProps } from '@components/Input';
import { Declension } from '@utils/Declension';

interface Props extends InputProps {
    valueType?: DurationType;
}

export enum DurationType {
    Minutes = 'minutes',
    Days = 'days',
    Hours = 'hours',
}

export const Duration = observer(({ valueType = DurationType.Minutes, ...props }: Props) => {
    let getDescription;

    switch (valueType) {
        case DurationType.Minutes: {
            getDescription = Declension.minutes;
            break;
        }
        case DurationType.Days: {
            getDescription = Declension.days;
            break;
        }
        case DurationType.Hours: {
            getDescription = Declension.hours;
            break;
        }
        default: {
            getDescription = Declension.minutes;
            break;
        }
    }

    return (
        <div className={styles.root}>
            <div className={styles.input}>
                <Input {...props} />
            </div>
            <div className={styles.description}>{getDescription(props.value)}</div>
        </div>
    );
});
